import { createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "revico-community-talk-modal-wrapper" }
const _hoisted_2 = { class: "revico-community-talk-modal-contents" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" 画面全体のオーバーレイ "),
    _createElementVNode("div", {
      class: _normalizeClass(`revico-community-talk-modal-overlay ${$setup.isOpen ? 'revico-community-talk-modal-open' : ''}`)
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createCommentVNode(" モーダル内部コンテンツ "),
        _createElementVNode("div", _hoisted_2, [
          _renderSlot(_ctx.$slots, "contents"),
          _createCommentVNode(" モーダル閉じるボタン "),
          _createElementVNode("button", {
            class: "revico-community-talk-modal--close-btn",
            onClick: $setup.closeModal
          })
        ])
      ])
    ], 2 /* CLASS */)
  ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
}